import React from "react";
import { Col, Form, Row } from "antd";
import LayoutContact from "./layout_contact";
import LayoutBasic from "./layout_basic";
import LayoutFinance from "./layout_finance";
import LayoutKyb from "./layout_kyb";
import LayoutDoc from "./layout_doc";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycLayout = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderHiddenVar = () => {
    return (
      <>
        <Form.Item name="contact" hidden initialValue={null} />
        <Form.Item name="basic" hidden initialValue={null} />
        <Form.Item name="finance" hidden initialValue={null} />
        <Form.Item name="kyb" hidden initialValue={null} />
      </>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Form layout="vertical" form={form}>
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {/* <LayoutContact />
          <LayoutBasic />
          <LayoutFinance />
          <LayoutKyb /> */}
          <LayoutDoc />
        </Col>
      </Row>
      {renderHiddenVar()}
    </Form>
  );
};
export default KycLayout;
